'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _spinnerSmall = require('./spinnerSmall.gif');

var _spinnerSmall2 = _interopRequireDefault(_spinnerSmall);

var _spinnerLarge = require('./spinnerLarge.gif');

var _spinnerLarge2 = _interopRequireDefault(_spinnerLarge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(_ref) {
  var loading = _ref.loading,
      small = _ref.small,
      message = _ref.message;

  var sizeClass = 'large';
  var spinnerImage = _spinnerLarge2.default;
  if (small) {
    spinnerImage = _spinnerSmall2.default;
    sizeClass = 'small';
  }

  return loading ? _react2.default.createElement('img', { className: 'spinner ' + sizeClass, src: spinnerImage, alt: message, title: message }) : null;
};

Spinner.defaultProps = { loading: false, small: false, message: '' };

Spinner.propTypes = {
  loading: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  message: _propTypes2.default.string
};

exports.default = Spinner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/Spinner.js
// module id = 198
// module chunks = 0